
import Vue from 'vue'
import { abi } from 'thor-devkit'

type Decoded = {
    def: abi.Function.Definition | abi.Event.Definition
    canonicalName: string
    params: Array<{ name: string, type: string, value: string, indexed?: boolean }>
}

export default Vue.extend({
    props: {
        value: Object as () => {
            data: string,
            topics?: string[]
        }
    },
    asyncComputed: {
        async decoded(): Promise<Decoded | null> {
            const val = this.value
            const sig = val.topics ? val.topics[0] : val.data.slice(0, 10)
            let defs: Array<abi.Function.Definition | abi.Event.Definition> | undefined = abiCache.get(sig)
            if (!defs) {
                defs = await queryABI(sig)
                abiCache.set(sig, defs)
            }

            for (const def of defs) {
                try {
                    if (def.type === 'event') {
                        const ev = new abi.Event(def)
                        const dec = ev.decode(val.data, val.topics!)
                        return {
                            def,
                            params: def.inputs.map((p, i) => {
                                return {
                                    name: p.name,
                                    type: p.type,
                                    value: dec[i],
                                    indexed: p.indexed
                                }
                            }),
                            canonicalName: ev.canonicalName
                        }
                    } else {
                        const fn = new abi.Function(def)
                        const dec = abi.decodeParameters(def.inputs, '0x' + val.data.slice(10))
                        return {
                            def,
                            params: def.inputs.map((p, i) => {
                                return {
                                    name: p.name,
                                    type: p.type,
                                    value: dec[i]
                                }
                            }),
                            canonicalName: fn.canonicalName
                        }
                    }
                } catch {
                    // continue
                }
            }
            return null
        }
    }
})

export const abiCache = new Map<string, any[]>()
export async function queryABI(sig: string) {
    const url = `https://b32.vecha.in/q/${sig}.json`

    const resp = await fetch(url)
    if (resp.status === 404) {
        return []
    }
    if (resp.status !== 200) {
        throw new Error(`Failed to query ABI (status: ${resp.status})`)
    }

    const json = await resp.json()
    if (!Array.isArray(json)) {
        throw new Error('Failed to query ABI (bad response)')
    }
    return json
}
